// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 60 60" {...rest} unit={unit}>
		<title>Selected</title>
		<g>
			<circle id="Oval" fill="#00B700" cx="30" cy="30" r="30"></circle>
			<polygon 
				id="Path" 
				fill="#FFFFFF" 
				fillRule="nonzero" 
				points="48 22.6185769 25.0909091 45.527667 12 32.5790509 18.1185771 
				26.3181815 25.0909091 33.2905133 41.8814229 16.5"></polygon>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Selected.js